import React from 'react'
import { NavText, ScaleSearch, ScaleUser } from '../NavElements'
import classes from '../css/Header.module.css'
import { Logo } from '../Logo/Logo'

interface Props {
       active?: boolean,
       color?: string
}

export const DefaultHeader: React.FC<Props> = (props) => {

    return (
    <header style={{backgroundColor: props.color && props.color}} className={props.active ? [classes.headerContainer, classes.navColor].join(' ') : classes.headerContainer}>
        <div className={classes.navContainer }>
            {/*<NavText to='/jobs'>وظائف/تدريبات للطلاب</NavText>*/}
            <NavText className={'mx-2'} to='/register'>التسجيل</NavText>
            <NavText  className={'mx-2'} to='/login'><ScaleUser size={22} /></NavText>
            <NavText className={'mx-2'} to='/jobs'><ScaleSearch size={22} /></NavText>
        </div>
        <NavText to='/'><Logo /></NavText>
        <div className={classes.navContainer+' justify-content-end'}>
            {/*<NavText to={{hash: '#contact-us', pathname: '/'}}>تواصل معنا</NavText>*/}
            <NavText className={'mx-2'} to='/jobs/graduates'>وظائف للخريجين</NavText>
            <NavText className={'mx-2'} to='/jobs'>جميع الوظائف</NavText>
        </div>

    </header>
    )
}